/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular.module('prism-ui.components').directive('checkboxList', function() {
	return {
		restrict: 'E',
		template: '<div ui-grid="checkboxListCtrl.gridOptions" class="checkbox-list-sm protected-grid" ui-grid-selection ui-grid-auto-resize></div>',
		controller: 'CheckboxListController',
		controllerAs: 'checkboxListCtrl',
		require: ['ng-model', 'checkboxList'],
		scope: {
			items: '='
		},
		bindToController: {
			items: '='
		},

		link: function(scope, elmnt, attrs, ctrls) {
			var ngModelCtrl = ctrls[0];
			var checkboxListCtrl = ctrls[1];
			checkboxListCtrl.modelCtrl = ngModelCtrl;

            /**
             * Called whenever the model is changed programatically and also on initial loading
             */
            ngModelCtrl.$formatters.push(function (modelValue) {
                checkboxListCtrl.setSelections();
                return modelValue;
            });
		}
	};
});
